const module = { name: 'fd-location/form/creation', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from '@grins/fd-modules/splits/require-core';



import { fd_location_form_events as fd_location_form_events_updateLocationName } from '@grins/fd-modules/splits/onering-global';

const { updateLocationName } = fd_location_form_events_updateLocationName;


import { fd_location_alertBox as alertBox } from '@grins/fd-modules/splits/onering-global';



import { Fandango as Fandango_context } from '@grins/fd-modules/splits/require-core';

const { context } = Fandango_context;


import { Fandango_clearableInput as clearableInput } from '@grins/fd-modules/splits/onering-global';



import { Fandango_dropdown as dropdown } from '@grins/fd-modules/splits/onering-global';



import { Fandango_overlay as overlay } from '@grins/fd-modules/splits/onering-global';



import { Fandango_eventQueue as eventQueue } from '@grins/fd-modules/splits/onering-global';



const { EventNames } = eventQueue


import { fd_location_form_events as locationFormEvents } from '@grins/fd-modules/splits/onering-global';



const { isMobile, locationOverlayEnabled } = readPageContext(context)


const Selectors = {
    DESKTOP_MOP_LOCATION_CONTAINER: '#movie-detail-layout-location-module',
    FORM_NAV: '#setLocationFormNav',
    LOCATION: '.js-location-overlay',
    LOCATION_INPUT: '#setLocationSearchInput',
}


const Styles = {
    LOCATION_DROPDOWN: 'location-dropdown',
    LOCATION_DROPDOWN_CLOSE_BTN: 'location-dropdown__close-btn',
    LOCATION_OVERLAY: 'location-overlay__wrapper',
    LOCATION_OVERLAY_CLOSE_BTN: ['location-overlay__close-btn', 'js-location-overlay-cancel']
}


const DEFAULT_DROPDOWN_NAME = 'locationModuleDesktopMOP'


const DATA_KEY = 'fdLocation'


let delegationBound = false


let closeEventName


let closeEvent


let attachedEvent
function readPageContext(context) {
    return {
        isMobile: context?.device?.isMobile,
        locationOverlayEnabled: context?.featureFlags?.locationOverlayEnabled
    };
}
function closeEventListener(cb) {
    closeEvent = eventQueue.on(EventNames.LOCATION_DROPDOWN_CLOSE, cb);
}
function onClick(e) {
    e.preventDefault();
    const opts = $(e.currentTarget).data(DATA_KEY) || {};
    let markup;
    function onOpen(modal) {
        locationFormEvents.init(modal);
        clearableInput.attach();
        alertBox.init();
        $(Selectors.LOCATION_INPUT).get(0).focus();
    }
    if (isMobile) {
        markup = swig.render('_locationOverlay', { isMobile });
        overlay.open(markup, {
            closeBtnStyle: Styles.LOCATION_OVERLAY_CLOSE_BTN,
            closeBtnParent: Selectors.FORM_NAV,
            closeBtnTabIndex: '0',
            closeBtnFirst: true,
            overlayStyle: Styles.LOCATION_OVERLAY,
            microModalOpts: {
                onShow: onOpen,
                onClose(modal) {
                    modal.remove();
                }
            }
        });
    }
    else {
        const { name, relativeParent } = opts.dropdown || {};
        const trigger = e.currentTarget;
        if (!trigger.id) {
            trigger.id = `js-location-trigger-${Date.now()}`;
        }
        markup = swig.render('_locationDropdown', { isMobile });
        dropdown.open(markup, {
            closeBtnStyle: Styles.LOCATION_DROPDOWN_CLOSE_BTN,
            dropdownStyle: Styles.LOCATION_DROPDOWN,
            name: name || DEFAULT_DROPDOWN_NAME,
            openParent: trigger.id,
            relativeParent: relativeParent || `#${trigger.id}`,
            closeEventListener,
            closeCB() {
                closeEvent && closeEvent.remove();
            },
            openCB: onOpen
        });
    }
}
function init(opts = {}) {
    updateLocationName(opts);
    if (isMobile && !locationOverlayEnabled) {
        return;
    }
    const triggerSelector = opts.trigger || Selectors.LOCATION;
    $(triggerSelector).data(DATA_KEY, opts);
    if (!delegationBound) {
        $(document).on('click.fdLocation', Selectors.LOCATION, onClick);
        delegationBound = true;
    }
    closeEventName = isMobile ? EventNames.LOCATION_OVERLAY_CLOSE : EventNames.LOCATION_DROPDOWN_CLOSE;
    eventQueue.on(closeEventName, updateLocationName);
}
function attach(attachEvent) {
    if (isMobile && !locationOverlayEnabled) {
        return;
    }
    if (attachedEvent) {
        attachedEvent.remove();
    }
    attachedEvent = eventQueue.on(closeEventName, attachEvent);
}
module.exports = {
    init,
    attach,
};
export default module.exports;